"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKOptions = void 0;
var base_58_1 = __importDefault(require("base-58"));
var js_sha256_1 = require("js-sha256");
var SDKOptions = (function () {
    function SDKOptions() {
        this.rules = {
            appKey: ['required', 'string'],
            apiURL: ['string', 'url'],
            build: ['string'],
            baseURL: ['string', 'url'],
            debug: ['boolean'],
            overrideConsoleMethods: ['boolean'],
            printToConsole: ['boolean'],
            logBrowserEvents: ['boolean'],
            logUIEvents: ['boolean'],
            registerErrorHandler: ['boolean'],
            version: ['string'],
        };
    }
    SDKOptions.prototype.init = function (options) {
        this.validate(options);
        return __assign({ appID: base_58_1.default.encode(js_sha256_1.sha256.array(options.appKey)).substring(0, 10), apiURL: 'https://api.bugfender.com', baseURL: 'https://dashboard.bugfender.com', debug: false, overrideConsoleMethods: true, printToConsole: true, logBrowserEvents: true, logUIEvents: true, registerErrorHandler: true, version: '0.0.0', build: '0' }, options);
    };
    SDKOptions.prototype.validate = function (options) {
        var urlValidator = new RegExp(/^http(s)?:\/\//i);
        Object.entries(this.rules).forEach(function (_a) {
            var key = _a[0], rules = _a[1];
            var value = options[key];
            rules.forEach(function (rule) {
                if (rule === 'required') {
                    if (typeof value === 'undefined') {
                        throw new Error("Bugfender requires '" + key + "' option to initialize.");
                    }
                }
                else if (rule === 'string') {
                    if (!['string', 'undefined'].includes(typeof value)) {
                        throw new Error("'" + key + "' option must be a string.");
                    }
                }
                else if (rule === 'url') {
                    if (typeof value !== 'undefined' && !urlValidator.test(value)) {
                        throw new Error("'" + key + "' option must be a valid URL.");
                    }
                }
                else if (rule === 'boolean') {
                    if (!['boolean', 'undefined'].includes(typeof value)) {
                        throw new Error("'" + key + "' option must be a boolean.");
                    }
                }
            });
        });
    };
    return SDKOptions;
}());
exports.SDKOptions = SDKOptions;
